"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ModelCompositorCategorys_1 = __importDefault(require("../models/ModelCompositorCategorys"));
const ServiceRateComposition_1 = __importDefault(require("../services/ServiceRateComposition"));
class ControllerRateCompositorTool {
    constructor(proposalId) {
        this.compositorToolService = new ServiceRateComposition_1.default(proposalId);
    }
    get modelCategories() {
        return new ModelCompositorCategorys_1.default(this.dataCompositionTool.rates);
    }
    get dataCompositionTool() {
        return this.compositorToolService.collectData;
    }
    get categoriesOrder() {
        var _a;
        return (_a = this.modelCategories) === null || _a === void 0 ? void 0 : _a.getOrderCategories();
    }
    get currentCategory() {
        return this.modelCategories.getCategoryHighestCounter();
    }
    get errorModel() {
        return this.compositorToolService.getErrorFetchData;
    }
    get isFailedCall() {
        return this.compositorToolService.isFailedCall;
    }
    async callDataCompositorTool() {
        await this.compositorToolService.call();
    }
    filterCategorysByCategory(category) {
        return this.modelCategories.filterByCategory(category);
    }
}
exports.default = ControllerRateCompositorTool;
